import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface CustomPaperProps {
  title: string;
  css: boolean;
  isMandatory: boolean;
}
const InputLabelComp = ({ title, css = false, isMandatory = false }: CustomPaperProps) => {
  return (
    <label className="text-lable" htmlFor="custom-select">
          {title} {isMandatory && <span style={{ color: "red" }}>*</span>}
    </label>
    
  );
};

export default InputLabelComp;
